export enum ProblemStatementEventEnum {
    goal = "problemStatementGoal",
    intervention = "problemStatementIntervention"
}
